import { createContext, useContext, useState } from "react";

export interface AuthData {
  token?: string;
  userId?: string;
  orgId?: string;
  fullName?: string;
  email?: string;
  phone?: string;
  isActive?: boolean;
  lastLogin?: string;
  profileId?: number;
  profileName?: string;
  profileDescription?: string;
  scope?: {
    org_id?: string;
    org_name?: string;
    project_id?: string;
    project_name?: string;
    program_id?: string;
    program_name?: string;
    department_id?: string;
    department_name?: string;
  };
}

interface AuthContextProps {
  isAuthenticated: boolean;
  auth: AuthData | null;
  login: (data: AuthData) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextProps | null>(null);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("login") === "true",
  );

  const [auth, setAuth] = useState<AuthData | null>(() => {
    const data = localStorage.getItem("auth");
    return data ? JSON.parse(data) : null;
  });

  function login(data: AuthData) {
    localStorage.setItem("login", "true");
    localStorage.setItem("auth", JSON.stringify(data));

    setAuth(data);
    setIsAuthenticated(true);
  }

  function logout() {
    localStorage.removeItem("login");
    localStorage.removeItem("auth");

    setAuth(null);
    setIsAuthenticated(false);
  }

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        auth,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be inside AuthProvider!");
  }

  return context;
};
